module.exports = __webpack_public_path__ + "static/media/icon_added.e0be0b94.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/icon_added.svg
// module id = 431
// module chunks = 0